import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CropSelectorComponent } from './crop-selector.component';
import {DxDropDownBoxModule, DxTextBoxModule, DxTreeViewModule} from 'devextreme-angular';



@NgModule({
  declarations: [CropSelectorComponent],
    imports: [
        CommonModule,
        DxDropDownBoxModule,
        DxTreeViewModule,
        DxTextBoxModule
    ],
  exports: [CropSelectorComponent]
})
export class CropSelectorModule { }
